import { render, staticRenderFns } from "./ProofForm.vue?vue&type=template&id=41fad546&scoped=true"
import script from "./ProofForm.vue?vue&type=script&lang=js"
export * from "./ProofForm.vue?vue&type=script&lang=js"
import style0 from "./ProofForm.vue?vue&type=style&index=0&id=41fad546&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41fad546",
  null
  
)

export default component.exports